class AppStorageSlot {
  constructor(appStorage, name, slotKeys = []) {
    this.appStorage = appStorage;
    this.name = name;
    this.slotKeys = slotKeys;
  }
  setSlotKeys(keys) {
    this.slotKeys = keys;
    return this;
  }
  save() {
    this.appStorage.save(this.name);
    return this;
  }
  reset() {
    this.appStorage.reset(this.name);
    return this;
  }
  update(values = {}, clean = true, save = true) {
    this.appStorage.appUtils.copyObjectValues(
      values,
      this.appStorage.target(this.name),
      clean,
      this.slotKeys,
    );

    return save ? this.save() : this;
  }
}

export default AppStorageSlot;
